import React from 'react';

import { NewStandardSection } from '@src/components/commons';

import { Button } from '@commons/button/Button';

import { paths } from '@src/constants/pathsEnum';

import Arrow from '../images/arrow.svg';

import * as styles from './arrow-text-button.module.scss';

export const ArrowTextButton = () => {
  const alt = 'Explore our stand-alone UX/UI design services';
  return (
    <NewStandardSection classNames={{ outerWrapper: styles.outerWrapper, innerWrapper: styles.innerWrapper }}>
      <img className={styles.image} src={Arrow} alt={alt} />
      <div className={styles.content}>
        <p className={styles.text}>
          Does your product require a different approach?
          <br />
          Get to know our <b>UX/UI design stand-alone services.</b>
        </p>
        <Button className={styles.button} href={paths.SERVICES.UX_UI_DESIGN} label="Visit our website" />
      </div>
    </NewStandardSection>
  );
};
